module.exports = __webpack_public_path__ + "img/icon_2.5fd5db1d.svg";